/*---------------------------
| Layout: Tablet/Desktop
---------------------------*/
export const GAP = 24;
export const TNP_LOGO_WIDTH = 84;
export const TNP_LOGO_TYPE_WIDTH = 183;
export const PRODUCTS_MENU_WIDTH = 286;
export const AUTH_MENU_TWO_COL_WIDTH = 362;
export const AUTH_MENU_THREE_COL_WIDTH = 518;
export const RIGHT_BLOCK_WIDTH = 149;
